import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../admin_resources/css/admin_layout.css";
import "../../admin_resources/css/admin_common.css";

const Admin_Header = () => {
  const [adminName, setAdminName] = useState("");
  const navigate = useNavigate(); // useNavigate 훅 사용
  const location = useLocation();
  const [permissions, setPermissions] = useState({
    site: false,
    board: false,
    form: false,
  });

  useEffect(() => {
    const savedAdminName = localStorage.getItem("adminName");
    console.log("adminName:", savedAdminName);
    if (savedAdminName) {
      setAdminName(savedAdminName);
    }

    // 관리자 권한 정보 가져오기
    const adminId = localStorage.getItem("adminId");
    if (adminId) {
      fetchPermissions(adminId);
    }
  }, []);

  const fetchPermissions = async (adminId) => {
    try {
      const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
      const data = await response.json();
      setPermissions(data); // 권한 정보를 상태로 설정
    } catch (error) {
      console.error("권한 정보를 가져오는 데 실패했습니다.", error);
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault(); // 기본 동작 방지

    const menuPermissions = [
      { key: "banner", path: "/admin/site/banner" },
      { key: "popup", path: "/admin/site/popup" },
      { key: "notice", path: "/admin/board/notice" },
      { key: "event", path: "/admin/board/event" },
      { key: "social", path: "/admin/board/social" },
      { key: "magazine", path: "/admin/board/magazine" },
      { key: "ent", path: "/admin/form/ent" },
      { key: "fr", path: "/admin/form/fr" },
      { key: "franchise", path: "/admin/form/franchise" },
      { key: "schedule", path: "/admin/form/schedule" },
      { key: "jisa", path: "/admin/form/jisa" },
      { key: "q", path: "/admin/form/q" },
      { key: "etc_q", path: "/admin/form/etc_q" },
    ];

    // 권한이 있는 첫 번째 메뉴로 이동
    for (let i = 0; i < menuPermissions.length; i++) {
      const permissionKey = menuPermissions[i].key;
      if (permissions[permissionKey]) {
        navigate(menuPermissions[i].path, {
          state: { adminName },
        });
        return;
      }
    }

    // 권한이 없는 경우 경고 메시지와 로그인 페이지로 리다이렉트
    alert("권한이 없습니다.");
    navigate("/admin/admin_login");
  };

  const handleLogout = () => {
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminDept");
    localStorage.removeItem("adminSuper");
    navigate("/admin/admin_login"); // 로그인 페이지로 리다이렉트
  };

  const handleMenuClick = (menu, e) => {
    e.preventDefault(); // 기본 링크 동작을 막음

    const menuPermissions = [
      { key: "banner", path: "/admin/site/banner", parentKey: "site" },
      { key: "popup", path: "/admin/site/popup", parentKey: "site" },
      { key: "notice", path: "/admin/board/notice", parentKey: "board" },
      { key: "event", path: "/admin/board/event", parentKey: "board" },
      { key: "social", path: "/admin/board/social", parentKey: "board" },
      { key: "magazine", path: "/admin/board/magazine", parentKey: "board" },
      { key: "ent", path: "/admin/form/ent", parentKey: "form" },
      { key: "fr", path: "/admin/form/fr", parentKey: "form" },
      { key: "franchise", path: "/admin/form/franchise", parentKey: "form" },
      { key: "schedule", path: "/admin/form/schedule", parentKey: "form" },
      { key: "jisa", path: "/admin/form/jisa", parentKey: "form" },
      { key: "q", path: "/admin/form/q", parentKey: "form" },
      { key: "etc_q", path: "/admin/form/etc_q", parentKey: "form" },
    ];

    // 큰 메뉴에 대한 권한을 확인
    const selectedMenu = menuPermissions.filter(
      (permission) => permission.parentKey === menu
    );

    console.log("선택된 메뉴:", menu);

    if (selectedMenu.length > 0) {
      // 작은 메뉴 권한을 확인
      const validMenu = selectedMenu.find(
        (permission) => permissions[permission.key]
      );

      if (validMenu) {
        navigate(validMenu.path, { state: { adminName } });
      } else {
        alert("권한이 없는 메뉴입니다.");
      }
    } else {
      alert("잘못된 메뉴입니다.");
    }
  };

  const getMenuBackgroundColor = (menuKey) => {
    if (location.pathname.includes(menuKey)) {
      return "#f5f5f5"; // 선택된 메뉴에 배경색 적용
    }
    return "transparent"; // 기본 배경색
  };

  return (
    <div className="admin_header">
      {/* <iframe name="proc" id="proc"></iframe> */}
      <table>
        <tbody>
          <tr className="top_info">
            <td className="logo">
              <button onClick={handleLogoClick}>아소비 웹 관리자</button>
            </td>
            <td className="toprigt">
              {adminName}님 로그인&nbsp;&nbsp;&nbsp;
              <span className="btn default" onClick={handleLogout}>
                {" "}
                로그아웃
              </span>
              &nbsp;&nbsp;
            </td>
          </tr>
        </tbody>
      </table>
      <ul className="sec_menu_top">
        <li style={{ backgroundColor: getMenuBackgroundColor("site") }}>
          <button
            onClick={(e) => handleMenuClick("site", e)}
            style={{ backgroundColor: getMenuBackgroundColor("site") }}
          >
            사이트 관리
          </button>
        </li>
        <li style={{ backgroundColor: getMenuBackgroundColor("board") }}>
          <button
            onClick={(e) => handleMenuClick("board", e)}
            style={{ backgroundColor: getMenuBackgroundColor("board") }}
          >
            게시판 관리
          </button>
        </li>
        <li style={{ backgroundColor: getMenuBackgroundColor("form") }}>
          <button
            onClick={(e) => handleMenuClick("form", e)}
            style={{ backgroundColor: getMenuBackgroundColor("form") }}
          >
            데이터 관리
          </button>
        </li>
        <li className="">
          <a
            href="https://www.asobiplanet.co.kr/ebook/conf/basic.php"
            target="_blank"
            rel="noreferrer"
          >
            ebook 관리
          </a>
        </li>
        <li style={{ backgroundColor: getMenuBackgroundColor("admin_info") }}>
          <a href="/admin/admin_info">정보수정</a>
        </li>
        <li>
          <a href="https://asobi.co.kr/" target="_blank" rel="noreferrer">
            홈페이지
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Admin_Header;
